import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider } from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import FieldView3 from 'core/components/layout/FieldView3';
import PackagingInfo from './PackagingInfo';
import OtherInfo from './OtherInfo';


export default function ProductInfo({ maxHeight }) {
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const {pharmaorderList} = useSelector((state) => state.pharmaslice);
  const {partyList} = useSelector((state) => state.pharmaslice);


  const getPartyName = () => {
    const orderObj = pharmaorderList.find(order => order.id === productObj?.orderid) || null;
    if (!orderObj===0) return "-";

    const partyObj = partyList.find(party => party.id === orderObj.partyid) || null;
    if (!partyObj) return "-";
    
    return partyObj.title; 

  }

  return (
    <Grid container sx={{ backgroundColor: 'secondary.100',  width: '100%', maxHeight:maxHeight?maxHeight:'70vh', overflowY: 'auto' }} >
      <Grid item lg={12} md={12} sm={12} xs={12} sx={{ }}>
        <Grid sx={{ backgroundColor: 'white', borderRadius: 2, m: 1, p: 1, }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', }}>
            Product
          </Typography>
          <Divider sx={{ borderStyle: 'dotted', }} />
          <Grid container direction="row" sx={{ width: '100%' }}>
            <Grid item lg={2} md={2} sm={2} xs={2} ><FieldView2 label="Order #" value={productObj?.orderid || "-"} /></Grid>
            <Grid item lg={7} md={2} sm={2} xs={8} ><FieldView2 label="Party" value={productObj?.partyname} /></Grid>
            <Grid item lg={3} md={2} sm={2} xs={2}><FieldView2 label="Type" value={productObj.repeatproduct?'REPEAT': "NEW"} /></Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} sx={{backgroundColor:'secondary.100'}}><FieldView2 label="Composition" value={productObj.title} /></Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}><FieldView2 label="Brand" value={productObj?.brandname || "-"} /></Grid>
            <Grid item lg={4} md={4} sm={4} xs={4}><FieldView2 label="Form" value={productObj?.formname || "-"} /></Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}><FieldView2 label="MRP" value={productObj?.mrptext || "-"} /></Grid>
            
            
            
            
            
            <Grid item lg={12} md={12} sm={12} xs={12}><FieldView2 label="Remarks" value={productObj.remarks?productObj.remarks:'-'} /></Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12} >
        <PackagingInfo />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12} >
        <OtherInfo />
      </Grid>


    </Grid>
  );
}